export const euro = (v) => {
  const n = Number(v || 0);
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export const num = (v, d = 0) =>
  new Intl.NumberFormat("it-IT", { maximumFractionDigits: d }).format(Number(v || 0));

export const dateIt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "—";
  }
};

export const STATI = {
  aperta: { label: "Aperta", cls: "bg-sky-100 text-sky-700 border-sky-200" },
  in_corso: { label: "In Corso", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  conclusa: { label: "Conclusa", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  fatturata: { label: "Fatturata", cls: "bg-violet-100 text-violet-700 border-violet-200" },
};

export const TRASFERTE_TIPI = {
  notti: "Indennità notti",
  hotel: "Hotel",
  pranzo: "Pranzo",
  carburante: "Carburante",
  pedaggio: "Pedaggio",
  altro: "Altro",
};
